import {
  getEditOnlyStatusId,
  isEditOnlySiteStatus
} from './editOnlyContext'

/**
 * Edit-only workflow URLs use `/site/:siteId/edit-only/:editOnlySiteId`.
 * `SitesEditOnly` list/API rows store the edit-only primary key on `id` and the parent site on `siteId`.
 * Never put `sitehistoryId` in the edit-only URL segment — GET /editSite/sites/:id expects the edit-only PK.
 */
export function resolveEditOnlyRouteIds(siteOrRow = {}) {
  const historyId = siteOrRow.historyId ?? siteOrRow.sitehistoryId ?? null
  const parentSiteId =
    siteOrRow.siteId || siteOrRow.SiteId || siteOrRow.Site?.id || null
  const editOnlySiteId = siteOrRow.id
  const statusId = getEditOnlyStatusId(siteOrRow)
  const isEditOnly =
    isEditOnlySiteStatus(statusId) ||
    Boolean(parentSiteId && editOnlySiteId && parentSiteId !== editOnlySiteId && !siteOrRow.reassessmentFlag)

  // Edit-only rows must win over reassessmentFlag / historyId fallbacks.
  if (isEditOnly && parentSiteId && editOnlySiteId && parentSiteId !== editOnlySiteId) {
    return { siteId: parentSiteId, editOnlySiteId }
  }

  if (siteOrRow.reassessmentFlag && historyId) {
    const siteId = parentSiteId || siteOrRow.id
    return { siteId, editOnlySiteId: historyId }
  }

  if (parentSiteId && editOnlySiteId && parentSiteId !== editOnlySiteId) {
    return { siteId: parentSiteId, editOnlySiteId }
  }

  // Last resort: keep edit-only PK in the second segment (never substitute sitehistoryId).
  return {
    siteId: parentSiteId || editOnlySiteId,
    editOnlySiteId
  }
}
